import { FadeUp, RevealLine } from "./AnimatedSection";
import { useLanguage } from "@/context/LanguageContext";

const MAP_IMAGE = "https://static.prod-images.emergentagent.com/jobs/4bcff601-ff05-4713-b2a7-2b2784a9df18/images/340a3f88047ed525de39592c7b09e37fcda3b2abd9f93ef939879e07271ccb86.jpeg";

export const GlobalReachMap = () => {
  const { t } = useLanguage();

  return (
    <section data-testid="global-reach-section" className="relative py-28 md:py-36 bg-[#0A0A0A] overflow-hidden">
      <div className="absolute inset-0 opacity-[0.22] pointer-events-none select-none">
        <img src={MAP_IMAGE} alt="" className="w-full h-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/40 via-[#0A0A0A]/80 to-[#0A0A0A]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-transparent to-[#0A0A0A]" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="max-w-2xl mb-16 md:mb-20">
          <p className="text-brand-red text-xs font-mono tracking-[0.25em] font-semibold uppercase mb-4">{t.globalReach.label}</p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white tracking-tight mb-5">
            <RevealLine text={t.globalReach.title} />
          </h2>
          <p className="text-neutral-400 text-base md:text-lg leading-relaxed">{t.globalReach.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.globalReach.regions.map((region, i) => (
            <FadeUp
              key={region.name}
              delay={i * 0.07}
              data-testid={`global-reach-region-${i}`}
              className="rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-xl p-6 hover:border-white/20 hover:-translate-y-1 transition-all duration-300"
            >
              <span className="text-3xl mb-4 block">{region.flag}</span>
              <h3 className="font-heading font-bold text-white text-lg mb-2">{region.name}</h3>
              <p className="text-neutral-400 text-sm leading-relaxed mb-4">{region.desc}</p>
              <p className="text-[11px] font-semibold text-neutral-500 tracking-wide border-t border-white/[0.08] pt-3">{region.platforms}</p>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
